// SAT Talep backend wrapper'i. Tum cagrilar apiClient uzerinden gider
// (cookie-auth, withCredentials already set).
import { apiClient } from "./apiClient";

export const SAT_CATEGORIES = ["unit_need", "it_need", "office_supplies", "general_supplies"];
export const SAT_PRIORITIES = ["low", "medium", "high"];

export const SAT_STATUSES = [
  "pending_supervisor",
  "pending_it",
  "pending_manager",
  "pending_hr",
  "completed",
  "rejected",
  "cancelled",
];

export const satRequestService = {
  // payload alanlari + opsiyonel `file` (proforma/teklif). file varsa
  // multipart gonderir.
  create: ({ file, ...payload } = {}) => {
    if (file) {
      const fd = new FormData();
      Object.entries(payload).forEach(([k, v]) => {
        if (v !== undefined && v !== null && v !== "") fd.append(k, String(v));
      });
      fd.append("file", file);
      return apiClient
        .post("/sat-requests", fd, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((r) => r.data);
    }
    return apiClient.post("/sat-requests", payload).then((r) => r.data);
  },

  listMine: () => apiClient.get("/sat-requests/my").then((r) => r.data),

  stats: () => apiClient.get("/sat-requests/stats").then((r) => r.data),

  statsByDepartment: (params = {}) =>
    apiClient
      .get("/sat-requests/stats/by-department", { params })
      .then((r) => r.data),

  statsByTeam: (params = {}) =>
    apiClient
      .get("/sat-requests/stats/by-team", { params })
      .then((r) => r.data),

  listAll: (filters = {}) =>
    apiClient.get("/sat-requests", { params: filters }).then((r) => r.data),

  getById: (id) => apiClient.get(`/sat-requests/${id}`).then((r) => r.data),

  // --- state transitions ---
  supervisorApprove: (id, note) =>
    apiClient
      .post(`/sat-requests/${id}/supervisor-approve`, { note })
      .then((r) => r.data),
  supervisorReject: (id, reason) =>
    apiClient
      .post(`/sat-requests/${id}/supervisor-reject`, { reason })
      .then((r) => r.data),

  // IT onayinda talep alanlarini da guncelleyebilir.
  // edits: { item_url?, quantity?, unit_price? } + note
  itApprove: (id, { note, item_url, quantity, unit_price } = {}) =>
    apiClient
      .post(`/sat-requests/${id}/it-approve`, {
        note: note || null,
        item_url: item_url || undefined,
        quantity: quantity !== undefined && quantity !== "" ? quantity : undefined,
        unit_price: unit_price !== undefined && unit_price !== "" ? unit_price : undefined,
      })
      .then((r) => r.data),
  itReject: (id, reason) =>
    apiClient.post(`/sat-requests/${id}/it-reject`, { reason }).then((r) => r.data),

  managerApprove: (id, note) =>
    apiClient
      .post(`/sat-requests/${id}/manager-approve`, { note })
      .then((r) => r.data),
  managerReject: (id, reason) =>
    apiClient
      .post(`/sat-requests/${id}/manager-reject`, { reason })
      .then((r) => r.data),

  // HR tamamlar: actual_price zorunlu, invoice link VEYA dosya
  hrComplete: (id, { invoice_url, actual_price, note, file }) => {
    if (file) {
      const fd = new FormData();
      fd.append("actual_price", String(actual_price));
      fd.append("file", file);
      if (invoice_url) fd.append("invoice_url", invoice_url);
      if (note) fd.append("note", note);
      return apiClient
        .post(`/sat-requests/${id}/hr-complete`, fd, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((r) => r.data);
    }
    return apiClient
      .post(`/sat-requests/${id}/hr-complete`, {
        invoice_url,
        actual_price,
        note: note || null,
      })
      .then((r) => r.data);
  },
  hrReject: (id, reason) =>
    apiClient.post(`/sat-requests/${id}/hr-reject`, { reason }).then((r) => r.data),

  cancel: (id) => apiClient.post(`/sat-requests/${id}/cancel`).then((r) => r.data),

  // Belge ekleme (her asamada opsiyonel): teklif/proforma + fatura.
  uploadProforma: (id, file) => {
    const fd = new FormData();
    fd.append("file", file);
    return apiClient
      .post(`/sat-requests/${id}/proforma`, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((r) => r.data);
  },
  uploadInvoice: (id, file) => {
    const fd = new FormData();
    fd.append("file", file);
    return apiClient
      .post(`/sat-requests/${id}/invoice`, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((r) => r.data);
  },
};
